<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{subCoverItemId ? 'Update' : 'Add'}} Sub Cover Item</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="subCoverItemForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title"  formControlName="title">
              <mat-error *ngIf="subCoverItemForm.controls['title'].touched && subCoverItemForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Average Cost For Repair</mat-label>
              <input type="number" matInput placeholder="Average Cost For Repair" formControlName="averageCostForRepair" min="0">
              <mat-error *ngIf="subCoverItemForm.controls['averageCostForRepair'].touched && subCoverItemForm.controls['averageCostForRepair'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="subCoverItemForm.controls['averageCostForRepair'].touched && subCoverItemForm.controls['averageCostForRepair'].hasError('min')">
                  Minimum value should be 0.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Average Cost For Replacement</mat-label>
                <input type="number" matInput placeholder="Average Cost For Replacement" formControlName="averageCostForReplacement" min="0">
                <mat-error *ngIf="subCoverItemForm.controls['averageCostForReplacement'].touched && subCoverItemForm.controls['averageCostForReplacement'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error *ngIf="subCoverItemForm.controls['averageCostForReplacement'].touched && subCoverItemForm.controls['averageCostForReplacement'].hasError('min')">
                    Minimum value should be 0.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Common Issues</mat-label>
                <input matInput placeholder="Common Issues"  formControlName="commonIssues">
                <mat-error *ngIf="subCoverItemForm.controls['commonIssues'].touched && subCoverItemForm.controls['commonIssues'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea type="text" matInput placeholder="Description" formControlName="description"> </textarea>
              <mat-error *ngIf="subCoverItemForm.controls['description'].touched && subCoverItemForm.controls['description'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
          </div>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="addEdit()">{{subCoverItemId ? 'Update' : 'Add'}}</button>
            <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
          </div>
          </form>
    </div>
  </div>
  

